import { render, staticRenderFns } from "./SzList.vue?vue&type=template&id=73b5a269&scoped=true&"
import script from "./SzList.vue?vue&type=script&lang=js&"
export * from "./SzList.vue?vue&type=script&lang=js&"
import style0 from "./SzList.vue?vue&type=style&index=0&id=73b5a269&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b5a269",
  null
  
)

export default component.exports